
import { onMounted, nextTick, watch, ref, computed } from 'vue'
import DotQueHalfScreenTile from "@/components/Aio/DotQueHalfScreenTile.vue"
export default {
  name: 'DotQueHalfScreen',
  props: {
    questionList: {
      type: Array,
      default: () => ([])
    },
    displayRange: {
      type: Number,
      default: 0
    },
    dotIndex: {
      type: String,
      default: '0'
    },
    curTime: {
      type: Number,
      default: 0
    },
    isCurrent: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DotQueHalfScreenTile
  },
  emits: ['handleAfterRender', 'handleChooseOption'],
  setup(props, {emit}) {
    const handleAfterRender = (data) => {
      console.log('==========if isCurrent===========')
      props.isCurrent && emit('handleAfterRender', {...data, dotIndex: props.dotIndex})
    }
    const handleChooseOption = (data) => {
      console.log(data, '=====handleChooseOption=======')
      emit('handleChooseOption', data)
    }
    onMounted(() => {
    })
    
    return {
      handleAfterRender,
      handleChooseOption
    }
  }
}
